var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "story-filter--main", attrs: { id: "story-filter--main" } },
    [
      _vm.includeFilter
        ? _c(
            "div",
            {
              staticClass: "story-filter__controls story-filter__inner",
              attrs: { id: "story-filter__inputs-container" }
            },
            [
              _c("div", { staticClass: "story-filter__category" }, [
                _c("div", { staticClass: "story-filter__category--select" }, [
                  _c(
                    "label",
                    {
                      staticClass: "story-filter__category--select-label",
                      attrs: { for: "stories__filter--select" }
                    },
                    [
                      _c("span", { staticClass: "access-hidden" }, [
                        _vm._v("Category Filter")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.category,
                              expression: "category"
                            }
                          ],
                          staticClass: "story-filter__category--input",
                          attrs: {
                            id: "stories__filter--select",
                            name: "category"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.category = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", {
                            attrs: { value: "" },
                            domProps: { textContent: _vm._s("All Categories") }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.categories, function(cat, index) {
                            return _c("option", {
                              key: index,
                              domProps: { value: cat, textContent: _vm._s(cat) }
                            })
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "story-filter__stories--container" }, [
        _c(
          "ul",
          { staticClass: "story-filter__stories" },
          _vm._l(_vm.renderedStories, function(story, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "card-container story-filter__story",
                on: { update: _vm.update }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "card__cards-wrapper",
                    attrs: { href: story.cta.link }
                  },
                  [
                    _c("div", { staticClass: "card__wrapper " }, [
                      _c("div", { staticClass: "card__image--large" }, [
                        _c("img", {
                          staticClass: "card__image",
                          attrs: { src: story.image.src, alt: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card__body" }, [
                        _c("div", { staticClass: "campaign-lockup" }, [
                          _c("p", {
                            staticClass: "campaign-lockup__heading card__link",
                            domProps: {
                              textContent: _vm._s(story.heading.copy)
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "campaign-lockup__body",
                            domProps: { textContent: _vm._s(story.body.copy) }
                          })
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "cta__standard cta__btn btn btn-blue",
            attrs: { id: "more-stories" },
            on: {
              click: function($event) {
                return _vm.displayStories()
              }
            }
          },
          [
            _c("span", { staticClass: "cta__copy" }, [
              _vm._v("Load More Stories")
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2f66268", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2f66268","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CampaignStoriesFilter.vue
// module id = null
// module chunks = 